'use strict';

/**
 * Model for saving the settings of the label print
 *
 * @category   Model
 * @module     base
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ModelLocal = require('base/Colido.ModelLocal');

var LabelPrintSettingsModel = ModelLocal.extend({
    defaults: {
        id: 1,
        labelMarginHorizontal: 0, // (0)
        labelMarginVertical: 26.25, // (26.25)
        labelWidth: 95, // (95)
        labelHeight: 42.5, // (42.5)
        labelPadding: 4, // (4)
        pageWidth: 210, // (210)
        pageHeight: 297, // (297)
        fontSizeScale: 1.1, // (1.1)
        printLogo: false, // (true|false)
        offsetX: 0, // (0)
        offsetY: 0, //
        printLines: true, // (true|false)
        isFoldingLabel: true, // (true|false)
        printPrice: true, // (true|false)
        units: 'mm', // (mm|cm|inch)
        convertCurrency: false,
        roundCurrency: false,
        roundNCurrency: 2,
        format: 'a4', // (a4|letter|custom)
    },

    /**
     * Name of the storage to use
     * @type {string|null}
     */
    storageKey: 'module:collection:settings-label-print',
});

module.exports = LabelPrintSettingsModel;